import axios from "axios";
import { API_URL, IndexDbStoreName, IndexedDbName } from "../zustand/const";
import { IndexedDBUtility } from "./IndexedDb";
import { isEmpty } from "underscore";
import { userStore } from "../zustand/index"; // Import userStore
import { Notify } from "notiflix";

let isLoggingOut = false; // Flag to prevent multiple logout triggers

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // If the response is successful, just return it
    return response;
  },
  (error) => {
    // Check if the error response has a status of 419 and we are not already logging out
    if (error.response && error.response.status === 419 && !isLoggingOut) {
      isLoggingOut = true; // Set the flag to true to prevent further triggers
      console.warn('Session expired or authentication failed. Forcing logout.');
      Notify.warning('Session expired or authentication failed. Forcing logout.');
      userStore.getState().logout();
      return Promise.reject(new Error('Session expired. logging out.'));
    }
    return Promise.reject(error);
  }
);

export async function getAuthToken() {
  let db = new IndexedDBUtility(IndexedDbName, IndexDbStoreName);
  await db.openDatabase();
  const token = await db.readFromDatabase('jwt');
  if (!isEmpty(token)) {
    const { jwt } = token;
    return jwt
  }
  return null
}

axiosInstance.interceptors.request.use(
  async (config) => {
    let db = new IndexedDBUtility(IndexedDbName, IndexDbStoreName);
    await db.openDatabase();
    const token = await db.readFromDatabase('jwt');
    if (!isEmpty(token)) {
      const { jwt } = token;
      config.headers.Authorization = `Bearer ${jwt}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const makeRequest = (method, url, data, headers) => {
  // if('')
  if (isEmpty(headers)) {
    headers = {
      "Content-Type": "application/json",
    };
  }
  return axiosInstance({
    method: method,
    url: url,
    data: data,
    headers: headers,
  });
};
export default axiosInstance;